import LegalPage from "../components/LegalPage";

const SECTIONS = [
  {
    heading: "Ce sunt cookie-urile",
    paragraphs: [
      "Cookie-urile sunt fișiere text mici, salvate pe dispozitivul tău atunci când vizitezi un site. Ele ajută site-ul să funcționeze corect și ne arată, anonim, cum este folosit.",
    ],
  },
  {
    heading: "Ce cookie-uri folosim",
    paragraphs: [
      "Cookie-uri strict necesare: esențiale pentru funcționarea site-ului (navigare, securitate). Acestea nu pot fi dezactivate.",
      "Cookie-uri de analiză: ne ajută să înțelegem câți vizitatori avem și ce pagini sunt citite, în formă anonimizată. Le folosim doar pentru a îmbunătăți site-ul.",
    ],
  },
  {
    heading: "Ce NU facem cu cookie-urile",
    paragraphs: [
      "Nu folosim cookie-uri de publicitate și nu urmărim activitatea ta pe alte site-uri.",
      "Nu vindem și nu partajăm datele de navigare cu terți în scopuri comerciale.",
    ],
  },
  {
    heading: "Cum le poți controla",
    paragraphs: [
      "Poți șterge sau bloca cookie-urile din setările browserului tău (Chrome, Safari, Firefox, Edge — secțiunea Confidențialitate/Securitate).",
      "Blocarea cookie-urilor strict necesare poate afecta funcționarea site-ului.",
    ],
  },
  {
    heading: "Actualizări ale acestei politici",
    paragraphs: [
      "Această politică poate fi actualizată periodic. Versiunea curentă este întotdeauna disponibilă pe această pagină.",
      "Pentru întrebări: contact@mymedas.ro sau 0711 981 550.",
    ],
  },
];

const PoliticaCookies = () => (
  <LegalPage
    title="Politica de cookie-uri"
    updated="iulie 2026"
    sections={SECTIONS}
    pageKey="cookies"
  />
);

export default PoliticaCookies;
